import en from './overwrites/en'
import it from './overwrites/it'

export default {
  en,
  it,
}
